import { addDays } from 'date-fns';
import { isNationalHoliday } from '../scheduling/server/otrs-calendar.js';

export async function getNextWorkingDay(
  date: Date,
  daysAtLeastInTheFuture = 1,
  isHoliday: (date: Date) => Promise<boolean> = isNationalHoliday,
) {
  let result = addDays(date, daysAtLeastInTheFuture);

  while (true) {
    const day = result.getDay();

    if (day === 0) {
      result = addDays(result, 1); // Sunday -> Monday
      continue;
    }
    if (day === 6) {
      result = addDays(result, 2); // Saturday -> Monday
      continue;
    }

    if (await isHoliday(result)) {
      result = addDays(result, 1);
      continue;
    }

    return result;
  }
}
